export default __webpack_public_path__ + "static/media/Pillar.1bb71c79.png";